module.exports = __webpack_public_path__ + "img/icon2.bc5f6ff5.png";